/**
 * @generated SignedSource<<0956ad1ba6fe0a2575800f57816138b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrdersList_viewer$data = {
  readonly transactionsPaginatedSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"OrdersListOrder_transaction">;
      } | null;
    } | null> | null;
    readonly numberOfPages: number | null;
  } | null;
  readonly " $fragmentType": "OrdersList_viewer";
};
export type OrdersList_viewer$key = {
  readonly " $data"?: OrdersList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrdersList_viewer">;
};

import OrdersListPaginationQuery_graphql from './OrdersListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "transactionsPaginatedSearch"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "excludeCanceled"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "viewName"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": OrdersListPaginationQuery_graphql
    }
  },
  "name": "OrdersList_viewer",
  "selections": [
    {
      "alias": "transactionsPaginatedSearch",
      "args": [
        {
          "kind": "Variable",
          "name": "excludeCanceled",
          "variableName": "excludeCanceled"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "viewName",
          "variableName": "viewName"
        }
      ],
      "concreteType": "TransactionsPaginatedSearchConnection",
      "kind": "LinkedField",
      "name": "__OrdersList_transactionsPaginatedSearch_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionsPaginatedSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OrdersListOrder_transaction"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9b15764ae6475061a0d944313f937909";

export default node;
